import { render } from "./MotPasseOubliePage.vue?vue&type=template&id=12c25d63&ts=true"
import script from "./MotPasseOubliePage.vue?vue&type=script&lang=ts"
export * from "./MotPasseOubliePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__